import { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { isNotEmpty } from "../../../helpers/StringHelpers"
import { Option } from "../../../services/ntuc/userService/staticData"
import { OccupationalGroupValidator } from "../../../services/validation/address-employment-form/OccupationalGroupField"
import { StaticDataContext } from "../../../views/signup-flow/SignupFormPage/SignupFormPage"
import { DropDown } from "../../DropDown/DropDown"
import { FormFieldProps } from "../../FormFieldProps/FormFieldProps"

const OccupationalGroupField = (props: FormFieldProps<Option>) => {
    const { t } = useTranslation(`signup`)
    const staticData = useContext(StaticDataContext)
    const [errorMessage, setErrorMessage] = useState(``)
    const [value, setValue] = useState(``)
    const {
        defaultValue,
        handleChange,
        errorText,
    } = props

    useEffect(() => {
        setErrorMessage(errorText ?? ``)
    }, [errorText])

    const validateField = () => {
        const validator = new OccupationalGroupValidator()
        const validationText = t(validator.validate(value) ?? ``)
        setErrorMessage(validationText)
    }

    const handleOnChange = (option: Option) => {
        setValue(option.value)
        handleChange(option)
    }

    const defaultOption = staticData?.occupation_group?.find(
        (option) => option.code === defaultValue?.code,
    )

    return (
        <DropDown
            title={t(`occupational_group`)}
            options={staticData?.occupation_group ?? []}
            showError={isNotEmpty(errorMessage)}
            errorMessage={t(errorMessage)}
            defaultValue={defaultOption}
            onChange={handleOnChange}
            onBlur={validateField}
        />
    )
}

export { OccupationalGroupField }